/* eslint-disable */
import React, { useEffect, useRef, useState, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";

// Material UI table
import { MaterialReactTable } from "material-react-table";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, putData, uploadMultipleFile } from "utils/Gateway";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { eventDetailsHeaderLinks } from "helper/EventHelper/EventHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import EventFeedbackGivenHeader from "../Header/EventFeedbackGivenHeader";
import { customKanbanSelectProcessStyle } from "Config/Config";
import { assetImages } from "constants";

const EventFeedbackGivenBody = () => {
  const { t, i18n } = useTranslation(); //for translation
  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const breadCrumbText = [
    { title: t("Event"), link: "/admin/events/list" },
    { title: t("Feedback 360") },
  ];

  const [commonHeaderObject, setCommonHeaderObject] = useState([]); // State for header links
  const [parentEventTitle, setParentEventTitle] = useState("");

  const [isEventModerator, setisEventModerator] = useState(false);

  const [eventMemberStatus, setEventMemberStatus] = useState("");
  const [eventModStatus, setEventModStatus] = useState("");
  const [isEventDetailsLoading, setIsEventDetailsLoading] = useState(false);

  const [feedbackRules, setFeedbackRules] = useState([]);
  const [surveyValue, setSurveyValue] = useState(null);

  const [tableColumns, setTableColumns] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [inviteList, setinviteList] = useState([]);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedInviteIds, setSelectedInviteIds] = useState([]);

  //* alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get details of event member
  const getMemberDetails = async () => {
    setIsEventDetailsLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_EVENT_MEMBER_DETAILS_BY_QUERY +
        `?token=${token}&eventid=${params.id}`;

      const response = await getData(requestUrl);

      console.log("response in member details", response);

      if (response.status) {
        setEventMemberStatus(response.data.memberstatus);
        setEventModStatus(response.data.moderatorstatus);
      } else {
        setAlertMessage(response.message);
        setMessageType("error");
        setShowAlert(true);
      }

      setIsEventDetailsLoading(false);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //function for get event details
  const getEventDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_EVENT_DETAILS +
        `/${params.id}?token=${token}&modulefrom=common`;

      // console.log("url of event gallery------>", requestUrl);

      const response = await getData(requestUrl);

      // console.log("response of event gallery------>", response);

      if (response.status && response.data) {
        getAllFeedbackRules();
        setParentEventTitle(response.data?.title);

        let isModerator = false;

        if (
          response.data.moderator._id.toString() === userInfo._id.toString() ||
          userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN"
        ) {
          isModerator = true;
        } else {
          getMemberDetails();
        }

        // Assign slug and update header links
        // response.data?.slug && setEventSlug(response.data?.slug);
        // set event type slug
        setCommonHeaderObject(
          eventDetailsHeaderLinks(
            params.id,
            t,
            response.data?.eventtype?.slug,
            isModerator
          )
        );

        setisEventModerator(isModerator);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all feedback rules
  const getAllFeedbackRules = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_SURVEY_LIST_BY_FEEDBACK_RULE +
        `?token=${token}&eventid=${params.id}`;

      const response = await getData(requestURL);

      if (response.status) {
        setFeedbackRules(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get survey details
  const getSurveyDetails = async (surveyId = null) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_SURVEY_DETAILS +
        `/${surveyId}` +
        `?token=${token}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        if (
          response.data.questionlist &&
          response.data.questionlist.length > 0
        ) {
          const updateQuestionList = response.data.questionlist.map(
            (question) => {
              return {
                accessorKey: question.code,
                header: question.name,
              };
            }
          );

          setTableColumns((prevColumns) => [
            ...prevColumns,
            ...updateQuestionList,
          ]);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all invites
  const getAllResponses = async (surveyId) => {
    setRowSelection({});
    setSelectedInviteIds([]);

    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_SURVEY_RESPONSE +
        `?token=${token}&filtersurveyid=${surveyId}`;

      const response = await getData(requestUrl);

      console.log(response);

      setIsLoading(false);
      if (response.status) {
        setinviteList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //fucntion for select survey
  const surveySelectionHandler = (val) => {
    if (val) {
      setTableColumns([
        {
          accessorKey: "inviteduser",
          header: t("Name"),
          Cell: ({ row }) => (
            <div className="name border-bottom-0">
              <div className="d-flex align-items-center gap-4">
                <div className="profile d-flex align-items-center gap-2">
                  <div
                    className="avatar rounded-circle overflow-hidden"
                    style={{ width: "35px", height: "35px" }}
                  >
                    <img
                      src={
                        row.original.inviteuserimage == ""
                          ? assetImages.defaultUser
                          : url.SERVER_URL + row.original.inviteuserimage
                      }
                      alt="Richard Hawail"
                      className="w-100 h-100 object-fit-cover object-center"
                    />
                  </div>
                  <div>
                    <p className="fs-md fw-semibold mb-0">
                      {row.original.invitedusername}
                    </p>
                    <Link to="#" className="d-block lh-1">
                      {row.original.email}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ),
        },
        {
          accessorKey: "responsedate",
          header: t("Response Date"),
        },
        //next question
        {
          accessorKey: "tags",
          header: t("Tags"),
          Cell: ({ row }) => (
            <div className="label border-bottom-0">
              {row.original.tagstring != "" && (
                <ul className="d-flex flex-wrap gap-2 fs-xs">
                  {row.original.tagstring.split(" , ").map((tag, index) => {
                    return (
                      <li
                        key={index}
                        className="px-2 py-1 gradient-light rounded-5"
                      >
                        {tag}
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          ),
        },
      ]);
      setSurveyValue(val);
      setTimeout(() => {
        getSurveyDetails(val.value);
        getAllResponses(val.value);
      }, 100);
    } else {
      setTableColumns([]);
      setSurveyValue(null);
      setinviteList([]);
    }
  };

  useEffect(() => {
    if (params.id) {
      getEventDetails();
    }
  }, [params.id]);

  /* Material React Table Column and States */
  const columns = useMemo(() => tableColumns, [tableColumns, i18n.language]);

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedInviteIds(selectedIdsArray);
    } else {
      setSelectedInviteIds([]);
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_EVENT")
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper crm-conversation-wrapper bg-white pb-5">
          {/* ---- common header ---- */}
          {params.id && (
            <TabsHeader
              commonHeaderObject={commonHeaderObject}
              activeOption={t("Feedback 360")}
            />
          )}
          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            <BreadCrumb
              breadCrumbText={breadCrumbText}
              bottom={true}
              displayName={`${parentEventTitle}`}
            />

            <EventFeedbackGivenHeader moduleSlug="feedbackgiven" />

            <div className="row align-items-center mb-3">
              <div className="col-3">
                <Select
                  placeholder={t("Start by selecting a feedback rule...")}
                  styles={customKanbanSelectProcessStyle}
                  menuPlacement="top"
                  options={feedbackRules}
                  isClearable
                  value={surveyValue}
                  onChange={surveySelectionHandler}
                />
              </div>
              <div className={surveyValue ? "col-3" : "d-none"}>
                <ul className="d-flex align-items-center gap-2">
                  <li role="presentation">
                    Survey Rules :{" "}
                    <span className="text-primary">{feedbackRules.length}</span>
                  </li>

                  <li role="presentation">
                    Total No of given feedback :{" "}
                    <span className="text-primary">{inviteList.length}</span>
                  </li>
                </ul>
              </div>
            </div>

            {surveyValue ? (
              <div>
                {isLoading ? (
                  <div className="placeholder-glow d-flex flex-column gap-4">
                    <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                    <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                    <span className="placeholder placeholder-lg bg-secondary col-4"></span>
                  </div>
                ) : (
                  <div className="table-wrapper">
                    <MaterialReactTable
                      columns={columns} // map columns to be displayed with api data,
                      data={inviteList} // data from api to be displayed
                      enableGrouping
                      enableRowSelection // enable showing checkbox
                      getRowId={(row) => row._id} // map which value to select with row checkbox
                      onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                      state={{ rowSelection }} //pass our managed row selection state to the table to use
                      // defaultColumn={{
                      //   minSize: 20,
                      //   maxSize: 300,
                      //   size: 50, //make columns wider by default
                      // }}
                      muiTableContainerProps={{
                        sx: {
                          maxHeight: "60vh",
                        },
                      }}
                      enableStickyHeader
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="challenges_empty text-center">
                <div className="empty_pic mb-4">
                  {" "}
                  <img src={assetImages.emptyVector} alt="" />
                </div>
                <div className="empty_text">
                  <p className="fs-lg text-gray fw-semibold mb-4">
                    Select a Feedback rule to get the feedbacks
                  </p>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default EventFeedbackGivenBody;
